import { projectCoverUrl } from './project-cover'
import { isCanvasProjectType } from './project-types'

function readObject (value) {
  if (typeof value === 'string') {
    try { value = JSON.parse(value) } catch (error) { return {} }
  }
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {}
}

function text (value, fallback = '') {
  return ['string', 'number'].includes(typeof value) ? String(value) : fallback
}

// 列表仅安全读取封面/首页尺寸，不迁移或补写项目 metadata。
export function screenProjectCard (record) {
  const metadata = readObject(record.metadata)
  const visual = readObject(metadata.visual)
  const config = readObject(metadata.config)
  let detail = readObject(config.detail)
  const pageProject = readObject(metadata.pageProject)
  if (Array.isArray(pageProject.pages)) {
    const home = pageProject.pages.find(page => page && page.id === pageProject.homePageId)
    if (home && home.config) detail = readObject(home.config)
  }
  const width = Number(detail.width), height = Number(detail.height)
  const state = readObject(record.state)
  return {
    record,
    id: text(record.id),
    name: text(record.name) || '未命名大屏',
    cover: projectCoverUrl(record) || text(visual.backgroundUrl),
    dimensions: Number.isFinite(width) && Number.isFinite(height) && width > 0 && height > 0 ? width + ' × ' + height : '尺寸未设置',
    status: text(state.text) || text(state.value) || text(record.state) || '未设置状态',
    enabled: state.value === 'enabled' || record.state === 'enabled',
    publicationLabel: record.publicationStatus === 'published' ? '已发布' : record.publicationStatus === 'unpublished' ? '未发布' : ''
  }
}

export function screenListResult (response, projectType) {
  const result = response && response.data && response.data.result
  if (!result || !Array.isArray(result.data) || result.data.some(record => !record || typeof record !== 'object' || Array.isArray(record)) || !['number', 'string'].includes(typeof result.total) || String(result.total).trim() === '' || !Number.isSafeInteger(Number(result.total)) || Number(result.total) < result.data.length) {
    throw new Error('大屏列表数据无效，请重试')
  }
  if (result.data.some(record => !['published', 'unpublished'].includes(record.publicationStatus))) {
    throw new Error('大屏列表发布状态无效，请确认后端已更新并重试')
  }
  // 不在浏览器删掉异类记录后冒用服务端总数；错误响应整体拒绝，避免串列表及分页失真。
  if (projectType !== undefined && (!isCanvasProjectType(projectType) || result.data.some(record => record.type !== projectType))) {
    throw new Error('项目列表类型不一致，请刷新重试')
  }
  return { records: result.data, total: Number(result.total) }
}

export function screenListError (error, fallback = '大屏列表加载失败，请重试') {
  return text(error && error.response && error.response.data && error.response.data.message) ||
    text(error && error.data && error.data.message) || text(error && error.message) || fallback
}

// 分类标签与新建表单使用相同的树路径和兄弟排序，不丢弃现有子分类。
export function screenCategoryOptions (items) {
  const seen = new Set()
  const flatten = (nodes, prefix = '', depth = 0) => {
    if (!Array.isArray(nodes) || depth > 32) throw new Error('分类列表数据无效，请重试')
    return [...nodes].sort((a, b) => (Number(a && a.sortIndex) || 0) - (Number(b && b.sortIndex) || 0)).flatMap(item => {
      if (!item || typeof item.id !== 'string' || !item.id || typeof item.name !== 'string' || !item.name.trim() || seen.has(item.id)) throw new Error('分类列表数据无效，请重试')
      seen.add(item.id)
      const label = prefix ? prefix + ' / ' + item.name : item.name
      return [{ id: item.id, label }, ...flatten(item.children || [], label, depth + 1)]
    })
  }
  return flatten(items)
}
